import { Component, Input } from "@angular/core";
import { ThemeService } from "src/services/theme.service";

@Component({
  selector: "vw-page-header",
  templateUrl: "./page-header.component.html",
})
export class PageHeaderComponent {
  @Input() showEmblemLogotype: boolean = false;

  constructor(public themeService: ThemeService) {}
}
